export const puppies = [
    {title:"Gallery", url:"puppies/gallery"},
    {title:"Enrichment", url:"puppies/enrichment"},
];